import { HashRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Hero from "./components/hero/Hero";
import Layout from "./components/Layout";
import Signup from "./components/Login/Signup";
import PythonIdeguide from "./components/pages/AllTopics/PythonTopics/PythonIdeguide";
import Pylecture1 from "./components/pages/AllTopics/PythonTopics/PythonSessions/Pylecture1";
import Pylecture2 from "./components/pages/AllTopics/PythonTopics/PythonSessions/Pylecture2";
import Pylecture3 from "./components/pages/AllTopics/PythonTopics/PythonSessions/Pylecture3";
import PythonTopics from "./components/pages/AllTopics/PythonTopics/PythonTopics";
import Contact from "./components/pages/Contact";
import NoPage from "./components/pages/NoPage";
import WhatsappGroupRedirect from "./components/WhatsappRedirect/WhatsappGroupRedirect";
import CountdownToTomorrow10AM from "./components/pages/CountdownToTomorrow10AM";

function App() {
  return (
    <>
      <HashRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Hero />} />
            <Route path="pytopics" element={<PythonTopics />} />
            <Route path="contact" element={<Contact />} />
            <Route path="signup" element={<Signup />} />
            <Route path="ideguide" element={<PythonIdeguide />} />
            <Route path="pyleacture1" element={<Pylecture1 />} />
            <Route path="pyleacture2" element={<Pylecture2 />} />
            <Route path="pyleacture3" element={<Pylecture3 />} />
            {/* <Route path="joinClassGroup" element={<WhatsappGroupRedirect />} /> */}
            {/* <Route path="class-1-16Nov" element={<CountdownToTomorrow10AM />} /> */}
            <Route path="class-1-16Nov" element={<WhatsappGroupRedirect />} />
            <Route path="*" element={<NoPage />} />
          </Route>
        </Routes>
      </HashRouter>
    </>
  );
}

export default App;
